import React from 'react';

import { CursoCartao } from 'Component/Curso';
import Curso from 'Interface/Cursos';
import { useRecuperarAssistirMaisTardeQuery } from 'Service';

const Default = (): React.ReactElement =>
{
    const { data: { assistir_mais_tarde } = {} } = useRecuperarAssistirMaisTardeQuery({
        contain: ['Cursos.Categorias'],
        sort: 'AssistirMaisTarde.criado',
        direction: 'desc',
    });

    return (
        <div className="animate__animated animate__fadeIn">
            <div
                className="hf-400 d-flex align-items-end"
                style={{
                    backgroundImage: 'linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 100%), url(/img/meus-cursos.jpg)',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    marginTop: '-130px',
                }}>
                    <div className="container text-center mb-5">
                        <h1 className="display-2 text-white">
                            Cursos para assistir mais tarde
                        </h1>
                        <p className="lead text-muted">
                            Aqui você encontra a lista de cursos que você deixou para assistir outra hora!
                        </p>
                    </div>
            </div>
            <div className="container mb-5">
                <div className="row px-3">
                    { assistir_mais_tarde?.map(assistir => (
                        <div className="col-md-3 mb-3" key={ `${assistir.id}-${assistir.criado}` }>
                            <CursoCartao
                                dados={ assistir.curso as Curso }
                            />
                        </div>
                    )) }
                </div>
            </div>
        </div>
    );
}

export default Default;
